<template>
  <svg v-if="sortState === null" xmlns='http://www.w3.org/2000/svg'
       preserveAspectRatio='none' width="24" height="24">
    <path fill='black' opacity='.3'
          d='M12.064 5.554l3.223 2.965 3.094 2.836H5.618l3.223-2.836zM12.064 18.446l3.223-2.965 3.094-2.836H5.618l3.223 2.836z'/>
  </svg>
  <svg v-else-if="sortState === false" xmlns='http://www.w3.org/2000/svg'
       preserveAspectRatio='none' width="24" height="24">
    <path fill='black'
          d='M12.064 5.554l3.223 2.965 3.094 2.836H5.618l3.223-2.836z'/>
    <path fill='black' opacity='.3'
          d='M12.064 18.446l3.223-2.965 3.094-2.836H5.618l3.223 2.836z'/>
  </svg>
  <svg v-else xmlns='http://www.w3.org/2000/svg'
       preserveAspectRatio='none' width="24" height="24">
    <path fill='black' opacity='.3'
          d='M12.064 5.554l3.223 2.965 3.094 2.836H5.618l3.223-2.836z'/>
    <path fill='black'
          d='M12.064 18.446l3.223-2.965 3.094-2.836H5.618l3.223 2.836z'/>
  </svg>
</template>

<script>
  export default {
    name: "SortIcon",
    props: ['sortState']
  }
</script>

<style scoped>

</style>
